export default __webpack_public_path__ + "static/area-with-negative-values-b34d929579a2b87ccd06eac91ed869fc.png";